import uniqueId from 'lodash/uniqueId';
import { AlertDefaults } from '../props/alert';

export const makeAlertActions = (prefix) => {
  const addAlertType = `${prefix}ADD_ALERT`;
  const removeAlertType = `${prefix}REMOVE_ALERT`;
  const clearAlertsType = `${prefix}CLEAR_ALERTS`;

  return {
    addAlert: ({ title, message = '', group = '', level = 'error', timeout = -1 }) => (dispatch) => {
      const payload = Object.assign({}, AlertDefaults, {
        id: uniqueId('alert-'), title, message, group, level, timeout: null
      });

      payload.onClose = () => {
        if (payload.timeout) {
          clearTimeout(payload.timeout);
        }
        dispatch({ type: removeAlertType, payload });
      };

      if (timeout > 0) {
        payload.timeout = setTimeout(() => {
          dispatch({ type: removeAlertType, payload });
        }, timeout);
      }

      dispatch({ type: addAlertType, payload });
    },
    clearAlerts: (group = '') => (dispatch) => dispatch({ type: clearAlertsType, payload: group })
  };
};
